import axios from '../../../helpers/axios-setup';
import { ProductInfoStep } from '../types';

export const saveProductInfo = (appId: number, params: ProductInfoStep) =>
  axios.patch(`/applications/builder/${appId}`, params);
